import * as Sentry from '@sentry/react';

import { ENV, IS_SENTRY_ENABLED } from '@hcs/webapps';
export type ExceptionHint = Sentry.EventHint;
export const logException = (
  messageOrError: string | Error,
  hint?: ExceptionHint
) => {
  const error =
    typeof messageOrError === 'string'
      ? new Error(messageOrError)
      : messageOrError;
  if (IS_SENTRY_ENABLED) {
    Sentry.captureException(error, hint);
  }
  if (ENV !== 'prod' && ENV !== 'stage') {
    console.error(error, hint);
  }
};

export const logWarning = (message: string) => {
  if (IS_SENTRY_ENABLED) {
    Sentry.captureMessage(message);
  }
  if (ENV !== 'prod' && ENV !== 'stage') {
    console.warn(message);
  }
};
